module.exports = __webpack_public_path__ + "static/img/revo.f346ee53.png";